import type React from "react";
import { cn } from "@/lib/utils";

export interface FAQItem {
	question: string;
	answer: React.ReactNode;
}

interface FAQProps {
	items: FAQItem[];
	className?: string;
}

/**
 * Native details/summary FAQ for MDX docs — avoids Base UI accordion useId
 * mismatches during SSR hydration (React #418 on long doc pages).
 */
export function FAQ({ items, className }: FAQProps) {
	if (!items || items.length === 0) {
		return null;
	}

	return (
		<div className={cn("col-span-full flex w-full flex-col", className)}>
			{items.map((item, index) => {
				const id = `faq-${index}`;
				return (
					<details
						key={id}
						className="group/faq border-b border-border last:border-b-0"
					>
						<summary className="flex cursor-pointer list-none items-center justify-between gap-2 py-2.5 text-sm font-medium hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 [&::-webkit-details-marker]:hidden">
							<span>{item.question}</span>
						</summary>
						<div className="pb-2.5 text-sm [&_a]:underline [&_a]:underline-offset-3 [&_p:not(:last-child)]:mb-4">
							{item.answer}
						</div>
					</details>
				);
			})}
		</div>
	);
}
